import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  // Active link helper (same logic, same colors)
  const isActive = (path) =>
    location.pathname === path
      ? "text-primary border-primary/50 bg-primary/10"
      : "text-slate-300 hover:text-primary border-transparent hover:border-primary/30";

  return (
    <nav className="sticky top-0 z-50 bg-background-light/90 dark:bg-background-dark/90 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
      <div className="flex items-center px-4 py-3 justify-between max-w-6xl mx-auto">

        {/* Logo + Brand */}
        <div className="flex items-center gap-2 shrink-0">
          <img
            src="/logo.png"
            alt="KrioGym Logo"
            className="w-16 h-8 md:w-20 md:h-10 object-contain"
          />
          <h2 className="text-lg md:text-2xl font-bold tracking-tight text-white whitespace-nowrap">
            Krio<span className="text-primary">Gym</span>
          </h2>
        </div>

        {/* Desktop Navigation (UNCHANGED) */}
        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive("/")}`}
          >
            Home
          </Link>
          <Link
            to="/exercises"
            className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive("/exercises")}`}
          >
            Exercises
          </Link>
          <Link
            to="/gallery"
            className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive("/gallery")}`}
          >
            Gallery
          </Link>
          <Link
            to="/contact"
            className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive("/contact")}`}
          >
            Contact
          </Link>
        </div>

        {/* Mobile Icons (TOP NAVBAR) */}
        <div className="flex md:hidden items-center gap-2 ml-2">
          <Link to="/" className={`p-1.5 rounded-md border ${isActive("/")}`}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 8L8 3L13 8V13H3V8Z" />
            </svg>
          </Link>

          <Link to="/exercises" className={`p-1.5 rounded-md border ${isActive("/exercises")}`}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 5h10M3 8h10M3 11h10" />
            </svg>
          </Link>

          <Link to="/gallery" className={`p-1.5 rounded-md border ${isActive("/gallery")}`}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="12" height="12" rx="2" />
              <circle cx="6" cy="6" r="1" />
            </svg>
          </Link>

          <Link to="/contact" className={`p-1.5 rounded-md border ${isActive("/contact")}`}>
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M14 10a3 3 0 01-3 3H5l-3 3V5a3 3 0 013-3h6a3 3 0 013 3z" />
            </svg>
          </Link>
        </div>

        {/* Location Badge (Desktop only, unchanged) */}
        <button className="hidden md:block text-xs font-bold uppercase tracking-widest text-primary border border-primary/30 px-4 py-2 rounded-full hover:bg-primary hover:text-black transition-colors">
          Ludhiana
        </button>

      </div>
    </nav>
  );
}



// import { Link, useLocation } from 'react-router-dom';

// export default function Navbar() {
//   const location = useLocation();
  
//   // Helper to check if link is active
//   const isActive = (path) => location.pathname === path 
//     ? 'text-primary border-primary/50 bg-primary/10' 
//     : 'text-slate-300 hover:text-primary border-transparent hover:border-primary/30';

//   return (
//     <nav className="sticky top-0 z-50 bg-background-light/90 dark:bg-background-dark/90 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
//       <div className="flex items-center px-4 py-3 justify-between max-w-6xl mx-auto">
        
//         {/* Logo + Brand Name */}
//         <div className="flex items-center gap-3">
//           <img 
//             src="/logo.png" // Replace with your actual logo path (public/logo.png)
//             alt="KrioGym Logo" 
//             className="w-20 h-10 object-contain " 
//           />
//           <h2 className="text-2xl font-bold tracking-tight text-white">
//             Krio<span className="text-primary">Gym</span>
//           </h2>
//         </div>

//         {/* Navigation Links - Hidden on mobile, shown on md+ */}
//         <div className="hidden md:flex items-center gap-8">
//           <Link 
//             to="/" 
//             className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive('/')}`}
//           >
//             Home
//           </Link>
//           <Link 
//             to="/exercises" 
//             className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive('/exercises')}`}
//           >
//             Exercises
//           </Link>
//           <Link 
//             to="/gallery" 
//             className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive('/gallery')}`}
//           >
//             Gallery
//           </Link>
//           <Link 
//             to="/contact" 
//             className={`text-sm font-medium transition-all px-3 py-2 rounded-lg border ${isActive('/contact')}`}
//           >
//             Contact
//           </Link>
//         </div>

//         {/* Location Badge */}
//         <button className="text-xs font-bold uppercase tracking-widest text-primary border border-primary/30 px-4 py-2 rounded-full hover:bg-primary hover:text-black transition-colors">
//           Ludhiana
//         </button>
//       </div>
//     </nav>
//   );
// }


// // import { Link } from 'react-router-dom';

// // export default function Navbar() {
// //   return (
// //     <nav className="sticky top-0 z-50 bg-background-light/90 dark:bg-background-dark/90 backdrop-blur-md border-b border-slate-200 dark:border-slate-800">
// //       <div className="flex items-center px-4 py-3 justify-between max-w-xl mx-auto">
// //         <div className="flex items-center gap-2">
// //           {/* Apna logo yahan daal do */}
// //           <img 
// //             src="/logo.png" 
// //             alt="KrioGym Logo" 
// //             className="w-9 h-9 object-contain" 
// //           />
// //           <h2 className="text-xl font-bold leading-tight tracking-tight text-white">
// //             Krio<span className="text-primary">Gym</span>
// //           </h2>
// //         </div>
// //         <button className="text-xs font-bold uppercase tracking-widest text-primary border border-primary/30 px-3 py-1 rounded-full hover:bg-primary hover:text-black transition-colors">
// //           Ludhiana
// //         </button>
// //       </div>
// //     </nav>
// //   );
// // }